import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { changePasswordSchema } from "../../schema";
import { changePassApi } from "../../api";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
import { useDispatch, useSelector } from "react-redux";
import { setIsLogin } from "../../redux/actions/roleAction";

const initialValues = {
  oldpassword: "",
  newpassword: "",
  confirmpassword: "",
};

const ChangeProfilePassword = () => {
  const { profileData } = useSelector((state) => state.profileReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useRef(null);

  const handleChangePass = async (values, action) => {
    changePassApi(values, profileData?.token)
      .then((response) => {
        toast.current.show({
          severity: "success",
          summary: `${response?.data?.message}`,
        });
        setTimeout(async () => {
          navigate("/");
          dispatch(setIsLogin(false));
        }, 1000);
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      });
  };

  const { values, errors, handleChange, handleSubmit, touched, handleBlur } =
    useFormik({
      initialValues,
      validationSchema: changePasswordSchema,
      onSubmit: (values, action) => handleChangePass(values, action),
    });

  return (
    <>
      <Toast ref={toast} />
      <div className="news-details-cls-portion mt-4">
        <div className="event-details-all-starting-part">
          <div className="userprofile-pics">
            <div className="change-profile-cls">
              <h6 className="mb-0 ms-0">Change password</h6>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="">
            <div className="main-profile-all-cls-start mt-4">
              <div className="details-all-name upload-user-profile-cls">
                <div className="row">
                  <div className="col-lg-6">
                    <label className="my-2">Old Password</label>
                    <input
                      type="password"
                      name="oldpassword"
                      formcontrolname="oldpassword"
                      maxLength="50"
                      className="form-control input-underline input-lg"
                      placeholder="Old Password"
                      value={values.oldpassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.oldpassword && touched.oldpassword ? (
                      <p className="form-error">{errors.oldpassword}</p>
                    ) : null}
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-lg-6">
                    <label className="my-2">New Password</label>
                    <input
                      type="password"
                      name="newpassword"
                      formcontrolname="newpassword"
                      maxLength="30"
                      className="form-control input-underline input-lg "
                      placeholder="New Password"
                      value={values.newpassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.newpassword && touched.newpassword ? (
                      <p className="form-error">{errors.newpassword}</p>
                    ) : null}
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-lg-6">
                    <label className="my-2">Confirm Password</label>
                    <input
                      type="password"
                      name="confirmpassword"
                      formcontrolname="confirmpassword"
                      maxLength="30"
                      className="form-control input-underline input-lg "
                      placeholder="Confirm Password"
                      value={values.confirmpassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {errors.confirmpassword && touched.confirmpassword ? (
                      <p className="form-error">{errors.confirmpassword}</p>
                    ) : null}
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-lg-6">
                    <div className="right-sidebtn-add text-end">
                      <div className="d-flex align-items-center justify-content-end">
                        <button
                          type="button"
                          className="btn btn-primary outline-btn-cls me-3"
                          onClick={() => {
                            navigate(-1);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary filled-btn-cls"
                          onChange={handleChange}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ChangeProfilePassword;
